
import barba from '@barba/core';
import { init as nl__init } from "../init.js";
import { cleanFunction } from './cleanup.js';
import { lenis } from "./lenis.js";

const init = async () => {
    history.scrollRestoration = "manual";
    var scrollPosY = 0;

    //according to lifecycle of barba
    //before hook
    barba.hooks.before(( data ) => {
        //console.log('before');        
        if (lenis) {
            lenis.stop();
        }
    });
    barba.hooks.beforeLeave(( data ) => {
        //console.log('beforeLeave');
        return cleanFunction(data.current.container); 
    });
    
    //leave hook
    barba.hooks.leave(( data ) => {
        //console.log('leave');
    });
    barba.hooks.afterLeave(( data ) => { 
        //console.log('afterLeave');        
        window.scrollTo(0, 0);
        if (lenis) {
            lenis.scrollTo(0, { immediate: true });
        }
    });
    
    //Enter hook
    barba.hooks.beforeEnter(( data ) => {  
        if (data.trigger !== "back" && data.trigger !== "popstate") {
            window.scrollTo(0, 0);
            if (lenis) {
                lenis.scrollTo(0, { immediate: true });
            }
        }
    });

    barba.hooks.enter( function (data) { 
        if(data.trigger !== "back" && data.trigger !== 'popstate') {
            scrollPosY = barba.history.current.scroll.y;    
            window.scrollTo(0, 0);
            if (lenis) {
                lenis.scrollTo(0, { immediate: true });
            }
        }    
    });
    
    barba.hooks.afterEnter( function (data) { 
        bodyClassUpdate(data);
        if (data.trigger !== "back" && data.trigger !== "popstate") {
            if ('scrollRestoration' in history) {
                history.scrollRestoration = 'manual';
            }
            
            // Multiple attempts to ensure scroll reset
            window.scrollTo(0, 0);
            if (lenis) {
                lenis.start();
                lenis.scrollTo(0, { immediate: true });
                
                // Force sync in next frame
                requestAnimationFrame(() => {
                    lenis.resize();
                    lenis.scrollTo(0, { immediate: true });
                    window.scrollTo(0, 0);
                });

                // And another one just to be absolutely sure
                setTimeout(() => {
                    window.scrollTo(0, 0);
                    lenis.resize();
                    lenis.scrollTo(0, { immediate: true });
                }, 50);
            }
        }
    });
    
    //Final hook
    barba.hooks.after((data) => {  
        if (lenis) {
            lenis.start();
        }
        nl__init();        
        if(data.trigger === "back" || data.trigger === 'popstate') {
            if (lenis) {
                lenis.scrollTo(scrollPosY, { immediate: true });                
            }
            jQuery(window).scrollTop(scrollPosY);            
        }        
    });

    function bodyClassUpdate(data) {
        const matches = data.next.html.match(/<body.+?class="([^""]*)"/i);
        document.body.setAttribute('class', (matches && matches.at(1)) ?? '');
    }   
};

export { init };